import {DataGrid} from "@mui/x-data-grid";
//import { GridColDef } from '@mui/x-data-grid';
import { Paper, Typography, Button, TextField} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import {preventDoubleClick} from "./preventDC.js"
import {useEffect, useState} from "react"
import { fetchCustomerbyDate2 } from "../api/customerapi";
//import { getCustomers } from "../actions/customer";
//import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(6),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
   
  },
    
}));

const Listcustdata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
 const [searchData3, setsearchData3] = useState([{}]);
const columns = [
  { field: 'cust_id', 
  headerName: ' Cust ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'cust_name',
    headerName: 'Name',
    width: width/12*2,
    
  },
   {
    field: 'createdAt',
    headerName: 'Created At',
    width: width/12*2,
    
  },
 {
    field: 'owner',
    headerName: 'Owner',
    width: width/12,
    
  },
   {
    field: 'cust_status',
    headerName: 'Status',
    width: width/12,
    
  },
   {
    field: 'roc',
    headerName: 'Canc Reason',
    width: width/12*2,
    
  },
   {
    field: 'notes',
    headerName: 'Notes',
    width: width/12*2,
    
  },
  {
    field: 'trip_status',
    headerName: 'Active Trips',
    width: width/12*3,
        /*valueGetter: (params) =>
      `${params.getValue(params.id, 'firstName') || ''} ${
        params.getValue(params.id, 'lastName') || ''
      }`,*/
  },
];

const [listcustData, setlistcustData]=useState([{
  cust_name: "",
  primary_mobile_number: undefined,
  chat_mobile_number: undefined,
  secondary_mobile_numbers: "",
  only_chat: false,
  marketing_message: true,
  cust_ref: "",
  cust_notes: "",
  cust_channel: "",
  primary_email_id: "",
  secondary_email_ids: "",
  cust_city: "",
  cust_state: "",
  cust_createdBy: "",
  cust_trips:[{
  id: undefined,
  status: ""
  }],
  follow_up:{
    roc:"",
    owner:"",
    status:"",
    notes:""
  }
}]);

const getCustomers = async () => {
  try{
    if(searchData3.start_date && searchData3.end_date){
        const data = await fetchCustomerbyDate2(searchData3.start_date, searchData3.end_date);
        setlistcustData(data.data)
    }else{
      alert("Enter dates and try again!")
    }
  //console.log(data);
  //const custdatalistfromdb= data.data
  
}catch(err){
  console.log(err)
}
}

// useEffect(() => {
//   getCustomers()
  
// }, [])

//   //console.log(listcustData);
//   listcustData.sort((a, b) => {
//     return a.cust_id - b.cust_id;
// });



  const custdatalistdisplay=listcustData.map(custdata=>({cust_name: custdata.cust_name, 
  id:listcustData.indexOf(custdata), 
  cust_id:custdata.cust_id, 
  primary_mobile_number:custdata.primary_mobile_number, 
  chat_mobile_number:custdata.chat_mobile_number, 
  trip_status: custdata.cust_trips.map(trip => (trip.status !=="Closed" && trip.status !=="Cancelled") ? trip.id : "").join(" "),
  owner:custdata.follow_up.owner,
  cust_status:custdata.follow_up.status,
  roc:custdata.follow_up.roc,
  notes:custdata.follow_up.notes,
  createdAt:custdata.createdAt
  }))
  //const custdatalistfromdb= useSelector((state)=> state.reducerNames);
 
  //console.log(listcustData);

  const gridcellclick=(id)=>{
    window.open = ("/custdataentry/"+id,"_blank");
    //console.log("/custdataentry/"+id);
  }

    return ( 
        <Paper variant="outlined" className={classes.paper}> 
        <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}> View Customers</Typography>
        <TextField
                         variant="outlined"
                         type="date"
                         label="Created On or after"
                         className={classes.textField}
                         InputLabelProps={{ shrink: true }}
                         onChange={(e) =>
                           setsearchData3({
                             ...searchData3,
                             start_date: e.target.value,
                           })
                         }
                       />
       
                       <TextField
                         variant="outlined"
                         type="date"
                         label="Created On or before"
                         className={classes.textField}
                         InputLabelProps={{ shrink: true }}
                         onChange={(e) =>
                           setsearchData3({ ...searchData3, end_date: e.target.value })
                         }
                       />
                       <Button onClick={preventDoubleClick(()=>getCustomers())} variant="contained"  color="inherit" className={classes.button}>Search</Button>
        </div>
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={custdatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.cust_id)}
        columns={columns}
        // pageSize={20}
        autoPageSize
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
     )
}
 
export default Listcustdata;